var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0886 4.41107C13.414 4.73651 13.414 5.26414 13.0886 5.58958L8.67786 10.0003L13.0886 14.4111C13.414 14.7365 13.414 15.2641 13.0886 15.5896C12.7632 15.915 12.2355 15.915 11.9101 15.5896L6.91009 10.5896C6.58466 10.2641 6.58466 9.73651 6.91009 9.41107L11.9101 4.41107C12.2355 4.08563 12.7632 4.08563 13.0886 4.41107Z",
    fill: "#0070B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.6cb78e13f0048c3aa02da8b018bfb3ea.svg";
export { ForwardRef as ReactComponent };